<template>
  <div v-if="superUser" class="container-fluid">
    <h3>Reporte Financiero de Tickets</h3>

    <div class="row">
      <div class="col-sm-2">
        <input v-model="filterOnlyClosed" type="checkbox">
        Sólo cerrados<br>
        <input v-model="filterOnlyOpen" type="checkbox">
        Sólo abiertos
      </div>
      <div class="col-sm-2 date-filter-title">
        <b>Filtrado por Fechas:</b>
      </div>
      <div class="col-sm-2">
        <div class="filter-date-type">
          <label><input v-model="selectedDate.type" type="radio" value="creation"> Creación Ticket</label><br>
          <label><input v-model="selectedDate.type" type="radio" value="updated"> Modificación</label><br>
          <label><input v-model="selectedDate.type" type="radio" value="closed"> Cerrado</label>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="filter-date-between">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Desde </span>
            </div>
            <input v-model="selectedDate.from" type="date" class="form-control" placeholder="desde">
          </div>
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <span class="input-group-text"> Hasta </span>
            </div>
            <input v-model="selectedDate.to" type="date" class="form-control" placeholder="hasta">
          </div>
        </div>
      </div>
      <div class="col-sm-3 filter-actions">
        <button class="btn btn-primary" @click="filter">
          Filtrar
        </button>
        <br>
        <button class="btn btn-danger" @click="removeFilter">
          Quitar
        </button>
      </div>
    </div>
    <div class="row">
      <div v-if="filteredIssuePLs.length" class="plist col-8">
        <div class="row">
          <div class="col-2">
            Ticket
          </div>
          <div class="col-2">
            F. Cerrado
          </div>
          <div class="col-8">
            Productos
          </div>
        </div>
        <div v-for="(issuePL, index) in filteredIssuePLs" :key="index" class="plistrow row">
          <div class="col-2">
            <!-- {{ getTicketDate(issuePL.dateCreated) }} <br> -->
            <a class="clickable" @click="goToIssue(issuePL.issue)">#{{ getTicketId(issuePL.issue) }}</a><br>
            {{issuePL.issue.customer.firstName}}<br>
            <span v-if="issuePL.issue.issueType">{{issuePL.issue.issueType}}</span>
            <span v-else>Smartdrone</span>
          </div>
          <div class="col-2">
            {{ formatDate(issuePL.dateClosed) }}<br>
            {{issuePL.paymentMethod}}
            <button v-if="issuePL.paymentMethod==='a cobrar'" class="btn btn-secondary mt-1" @click="paid(issuePL)">
              Cobrado
            </button>
          </div>
          <div class="col-8">
            <table style="width:100%;">
              <thead>
                <tr>
                  <th>Producto</th>
                  <th>Precio</th>
                  <th>Costo</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, index1) in issuePL.productLines" :key="index1">
                  <td>{{product.product.description}}</td>
                  <td>$ {{product.price}}</td>
                  <td>$ {{product.cost}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td><b>Total:</b></td>
                  <td>$ {{ getTotalPrices(issuePL.productLines) }}</td>
                  <td>$ {{ getTotalCosts(issuePL.productLines) }}</td>
                </tr>
                <tr v-if="issuePL.closed">
                  <td><b>Cobrado</b></td>
                  <td colspan="2">
                    <b>$ {{issuePL.paymentPrice}}</b>
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>
      <div v-else class="col-8">
        <p> No hay datos para el período seleccionado </p>
      </div>
      <div class="col-4">
        <h4> Según período seleccionado </h4>
        <p>Balance: <span :class="checkBalance">$ {{balance}}</span></p>
        <hr>
        <p>Cobros Totales: <b>$ {{priceTotalFormatted}}</b></p>
        <p>Costos Totales: <b>$ {{costTotalFormatted}}</b></p>
        <div v-if="priceTotal && costTotal">
          <vue-frappe
            id="balance"
            :labels="[
              'Salidas','Entradas'
            ]"
            :height="100"
            type="percentage"
            :colors="['red', 'green']"
            :data-sets="[{name: 'Values', values: [costTotal, priceTotal]}]"
          />
        </div>
        <div v-if="priceTotal && costTotal">
          <h5>Repuestos Usados</h5>
          <ul class="product-list">
            <li v-for="(qty, prodName) in productsUsedList" :key="prodName">
              <span>{{prodName}}</span> - {{qty}}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <header class="jumbotron">
      <h3> No deberías estar aquí.</h3>
    </header>
  </div>
</template>

<script>
import ProductService from '@/services/product.service';
import { getTicketId, formatDate } from '@/utils/page-utils';
// import { EventBus } from '@/utils/event.bus.js';

export default {
    name: 'IssueProductsReport',
    data() {
        return {
            issueProductLists: [],
            filteredIssuePLs: [],
            productsUsedList: {},
            filterOnlyClosed: false,
            filterOnlyOpen: false,
            selectedDate: {
                type: 'creation',
                from: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().substr(0, 10),
                to: new Date().toISOString().substr(0, 10)
            },
            balance: 0,
            costTotal: 0,
            priceTotal: 0,
            costTotalFormatted: 0,
            priceTotalFormatted: 0,
            selectedCustomer: -1,
            superUser: false,
            customers: []
        };
    },
    computed: {
        technicians() {
            return this.$store.state.technicians.technicians;
        },
        currentUser() {
            return this.$store.state.auth.user;
        },
        customerUser() {
            return !this.superUser && this.currentUser && !this.currentUser.roles.includes('ROLE_TECHNICIAN') && this.currentUser.roles.includes('ROLE_CUSTOMER');
        },
        checkBalance() {
            if (this.balance > 0) {
                return 'greenBalance';
            } else if (this.balance < 0) {
                return 'redBalance';
            }
            return 'neutralBalance';
        }
    },
    created() {
        this.superUser = this.$store.state.auth.user.roles.includes('ROLE_ADMIN');
        if (this.superUser) {
            this.getData(true);
        }
    },
    methods: {
        getData(thisMonth) {
            if (thisMonth) {
                return ProductService.getThisMonthPLs().then(
                    response => {
                        this.filteredIssuePLs = response.data;
                        this.processBalance();
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            } else
            if (!this.issueProductLists.length) {
                ProductService.getAllProductList().then(
                    response => {
                        // reset sanity...
                        this.issueProductLists = response.data;
                        this.filteredIssuePLs = this.issueProductLists;
                        this.runFilters();
                        // this.processBalance();
                    },
                    error => {
                        console.log(error.response && error.response.data ||
                  error.message || error.toString());
                    }
                );
            } else {
                this.runFilters();
            }
        },
        runFilters() {
            var fromDate, toDate;
            if (this.issueProductLists.length) {
                this.filteredIssuePLs = this.issueProductLists;
                this.filteredIssuePLs = this.filteredIssuePLs.filter(issuePL => {
                    if (!issuePL.productLines.length) {
                        return false;
                    }
                    if (this.filterOnlyClosed) {
                        return issuePL.closed === true;
                    } else if (this.filterOnlyOpen) {
                        return issuePL.closed === false;
                    }
                    return true;
                });

                if (this.selectedDate.from !== '') {
                    fromDate = new Date(this.selectedDate.from).getTime();
                    toDate = new Date(this.selectedDate.to).getTime();

                    if (fromDate > toDate) {
                        toDate = fromDate;
                    }

                    this.filteredIssuePLs = this.filteredIssuePLs.filter(issuePL => {
                        var theDate;
                        if (this.selectedDate.type === 'creation') {
                            theDate = new Date(issuePL.issue.dateCreated.split('T')[0]).getTime();
                        } else if (this.selectedDate.type === 'updated') {
                            if (issuePL.issue.dateModified) {
                                theDate = new Date(issuePL.issue.dateModified.split('T')[0]).getTime();
                            }
                        } else if (issuePL.dateClosed) {
                            theDate = new Date(issuePL.dateClosed.split('T')[0]).getTime();
                        }

                        return theDate && fromDate <= theDate && toDate >= theDate;
                    });

                }

                this.processBalance();
            }
        },
        getTotalPrices(lines, startingVal) {
            var retVal = startingVal || 0;
            lines.forEach(product => {
                retVal += product.price * product.quantity;
            });
            return retVal;
        },
        getTotalCosts(lines, startingVal) {
            var retVal = startingVal || 0;
            lines.forEach(product => {
                if (product.cost) {
                    retVal += product.cost * product.quantity;
                }
            });
            return retVal;
        },
        processProducts(lines, map) {
            let retVal = map;
            lines.forEach(product => {
                retVal[product.product.name] > 0 ?
                    retVal[product.product.name] = retVal[product.product.name] + product.quantity
                    : retVal[product.product.name] = product.quantity;
            });
            return retVal;
        },
        processBalance() {
            this.priceTotal = 0;
            this.costTotal = 0;
            this.productsUsedList = {};
            this.filteredIssuePLs.forEach(plist => {
                this.priceTotal += plist.paymentPrice;
                this.costTotal = this.getTotalCosts(plist.productLines, this.costTotal);
                this.productsUsedList = this.processProducts(plist.productLines, this.productsUsedList);
            });
            this.balance = this.priceTotal - this.costTotal;

            // parse it to 2 decimals.
            this.costTotalFormatted = parseFloat(this.costTotal).toFixed(2);
            this.priceTotalFormatted = parseFloat(this.priceTotal).toFixed(2);
            this.balance = parseFloat(this.balance).toFixed(2);
        },
        goToIssue(val) {
            // this.$router.push({
            //     name: 'tickets',
            //     params: { issue: val }
            // });
            this.$router.push({
                name: 'aticket',
                query: { ticketId: val.id },
                params: {
                    issue: response.data,
                    technicians: self.technicians,
                    isCustomer: self.customerUser,
                    superUser: self.superUser
                }
            });
            // EventBus.$emit('internalSearch', val);
        },
        paid(plist) {
            plist.paymentMethod = 'está pago';
            ProductService.closeProductsList(plist).then(
                responseData => {
                    // done
                },
                error => {
                    console.log(error.response && error.response.data ||
              error.message || error.toString());
                }
            );
        },
        filter() {
            this.getData(false);
        },
        removeFilter() {
            if (this.issueProductLists) {
                this.filteredIssuePLs = this.issueProductLists;
                this.processBalance();
            }
        },
        formatDate,
        getTicketId
    }
};
</script>
<style lang="scss">
ul.product-list {
    list-style: none;
    padding-left: 5px;
    li {
        font-weight: bold;
        span {
            font-weight: normal;
        }
    }
}
.plistrow {
    border-bottom: 1px solid #CACACA;
    tfoot {
        border-top: 1px solid #CACACA;
    }
}
.greenBalance {
    color: green;
    font-weight: bold;
}
.redBalance {
    color: red;
    font-weight: bold;
}
.neutralBalance {
    font-weight: bold;
}
.filter-actions {
    button {
        width: 125px;
        margin-bottom: 5px;
    }
}
.frappe-chart .chart-legend {
    display: none;
}
a.clickable {
    cursor: pointer;
}
</style>
